module.exports = __webpack_public_path__ + "static/img/guide_1_1_2.6e78609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_1_1_2.jpg
// module id = Bt+P
// module chunks = 1